'use client';

import Image from 'next/image';
import Link from 'next/link';
import {
  APP_STORE_BADGE,
  PLAY_STORE_BADGE,
  ZANGIA_APP_STORE_URL,
  ZANGIA_PLAY_STORE_URL,
} from '@/lib/app-download/constants';

type StoreBadgeLinksProps = {
  iosUrl?: string;
  androidUrl?: string;
  className?: string;
  badgeWidth?: number;
  badgeHeight?: number;
  useCustomImage?: boolean;
};

export default function StoreBadgeLinks({
  iosUrl = ZANGIA_APP_STORE_URL,
  androidUrl = ZANGIA_PLAY_STORE_URL,
  className = 'flex flex-col items-center gap-2.5',
  badgeWidth = 120,
  badgeHeight = 40,
}: StoreBadgeLinksProps) {
  return (
    <div className={className}>
      <Link
        href={iosUrl}
        prefetch={false}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Image
          src={APP_STORE_BADGE}
          alt="App Store"
          width={badgeWidth}
          height={badgeHeight}
          style={{ height: `${badgeHeight}px`, width: 'auto' }}
        />
      </Link>
      <Link
        href={androidUrl}
        prefetch={false}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Image
          src={PLAY_STORE_BADGE}
          alt="Google Play"
          width={badgeWidth}
          height={badgeHeight}
          style={{ height: `${badgeHeight}px`, width: 'auto' }}
        />
      </Link>
    </div>
  );
}
